import axios from 'axios';

const createClient = async (client) => axios.post(`/clients`, client);

const fetchClient = async (id) => axios.get(`/clients/${id}`);

const fetchClients = async (params) => axios.get(`/clients`, { params });

const deleteClient = async (id) => axios.delete(`/clients/${id}`);

const updateClient = async (id, client) => axios.put(`/clients/${id}`, client);

export default {
  fetchClient,
  deleteClient,
  fetchClients,
  createClient,
  updateClient,
};
